<template>
<span>
    <button v-if="isCollapsible"
            type="button"
            @click="toggleCollapse"
            class="odr-section-collapsible__header"
            :class="{'odr-section-collapsible__header--expand': !isCollapsed}">
        <span v-if="isCollapsed">
            <icon key="shown" size="s">keyboard_arrow_right</icon>
        </span>
        <span v-else>
            <icon key="hidden" size="s">keyboard_arrow_down</icon>
        </span>
        <slot></slot>
    </button>
    <div v-else class="odr-section-collapsible__header">
        <slot></slot>
    </div>
</span>
</template>

<script>
import { sectionCollapsibleBus } from '@/utils/section-collapsible-bus';

export default {
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
    data () {
        return {
            isCollapsed: false,
        };
    },
    computed: {
        isCollapsible () {
            return this.$parent.isCollapsible;
        },
        qaName () {
            return this.$parent.qaName;
        },
    },
    methods: {
        toggleCollapse () {
            this.isCollapsed = !this.isCollapsed;
            sectionCollapsibleBus.$emit(`section-collapse:${this.qaName}`, this.isCollapsed);
        },
    },
};
</script>
